/**
 * Seller Inventory Batch Rejected Item Table Columns
 *
 * It's important that we're using React.useMemo
 * here to ensure that our data isn't recreated on every render.
 * see https://react-table.tanstack.com/docs/quick-start
 */
const rejectedItemTableColumns = () => (
  [
    {
      Header   : 'SKU',
      accessor : 'sku'
    },
    {
      Header         : 'Product Info',
      accessor       : 'product_info',
      disableFilters : true
    },
    {
      Header         : 'Curation Status',
      accessor       : 'curation_status',
      disableFilters : true
    },
    {
      Header         : 'Reject Reason',
      accessor       : 'reject_reason',
      disableFilters : true
    }
  ]
)

export default rejectedItemTableColumns